var _excluded = ["appearance"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { ListingTypeName } from '@domain-group/fe-allhomes-library';
import { AllhomesSearchListingCard } from './search-result-card';
import AllhomesSearchListingCardGraphQL from './search-result-card-graphql';
import { NewHomesSearchResultCard } from '../new-homes-search-result-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getLayout = _ref => {
  var media = _ref.media,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'vertical' : _ref$appearance;
  if (appearance === 'vertical') {
    return 'vertical';
  }
  return media.desktop ? 'three-column' : 'two-column';
};
var ExportedListingCard = _ref2 => {
  var appearance = _ref2.appearance,
    props = _objectWithoutProperties(_ref2, _excluded);
  var media = useContext(MediaContext);
  var layout = getLayout({
    media,
    appearance
  });
  return props.listing.type === ListingTypeName.DEVELOPMENTS_RESIDENTIAL ? ___EmotionJSX(NewHomesSearchResultCard, _extends({}, props, {
    layout: layout
  })) : ___EmotionJSX(AllhomesSearchListingCard, _extends({}, props, {
    appearance: appearance
  }));
};
export { ExportedListingCard as AllhomesSearchListingCard, AllhomesSearchListingCardGraphQL };